import get from "loadsh/get";
import { useCallback, useEffect, useState } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  useNavigate,
} from "react-router-dom";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux";
import { lazy, Suspense } from "react";
import i18n from "i18next";
import { MaintenancePage } from "./component/MaintenancePage";
import Type_paymentTable from "./pages/type_payment/type_paymentTable";
import CIties from "./pages/cities";

// import ResponsiveMessage from "./Responsive";

const CardList = lazy(() => import("./pages/CompanyTransport/CardList"));
const UserForm = lazy(() => import("./pages/auth/Login"));
const AppLayout = lazy(() => import("./component/AppLayout"));
const CardList1 = lazy(() => import("./pages/EmployeeNew/CardList"));
const Notifcation1 = lazy(() => import("./pages/Notification/CardList"));
const ComplaintsList = lazy(() => import("./pages/Complaints/ComplaintsList"));
const Filter = lazy(() => import("./component/Filter"));
const CardListRating = lazy(() => import("./pages/Rating/CardListRating"));
const CardListComplaint = lazy(() =>
  import("./pages/Complaint/CardListComplaint")
);
const CardListTrashed = lazy(() =>
  import("./pages/EmployeeNew/CardListTrashed")
);
const CompanyEditForm = lazy(() =>
  import("./pages/CompanyTransport/CompanyEditForm")
);
const DeactiveClient = lazy(() =>
  import("./pages/Deactiv-client/Deactive-client")
);
const CardList2 = lazy(() => import("./pages/CompanyTransport/CardList2"));
const EmployeeAdmin = lazy(() => import("./pages/EmployeeNew/CardList2"));
const RestorCompanyTable = lazy(() =>
  import("./pages/Complaints/RestorCompanyTable")
);
const Permission = lazy(() =>
  import("./pages/EmployeeNew/Permission/Permissions")
);
const CardListAdminTrashed = lazy(() =>
  import("./pages/EmployeeNew/CardListAdminTrashed")
);
const AddPrivacyPolicy = lazy(() =>
  import("./pages/Privacypolicy/addPrivacyPolicy")
);
const ProfitTable = lazy(() => import("./pages/provit/provitTable"));
const UsersAppTable = lazy(() => import("./pages/usersapp/usersTable"));
const TransportCompanyData = lazy(() =>
  import("./pages/Complaints/TranspotCompanyData")
);
const ResponsiveMessage = lazy(() => import("./Responsive"));
const ErrorPage1 = lazy(() => import("./pages/Error/ErrorPage"));
const ErrorPage = lazy(() => import("./component/ErrorPage"));
const isLoggedIn = localStorage.getItem("isLoggedIn");
const Redirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate("/");
    } else {
      i18n.changeLanguage("ar"); // Set the language to Arabic
    }
  }, [isLoggedIn, navigate, i18n]);
};
const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
        {isLoggedIn ? <AppLayout /> : <UserForm />}
      </Suspense>
    ),
    errorElement: (
      <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
        <ErrorPage />
      </Suspense>
    ),
    children: [
 

      {
        path: "/TransportCompanyData",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <CardList />
          </Suspense>
        ),
      },
      {
        path: "/Empolyees",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <CardList1 />
          </Suspense>
        ),
      },
      {
        path: "/company/:id/trip-type",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <TransportCompanyData />
          </Suspense>
        ),
      },
      {
        path: "/Empolyees11",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <CompanyEditForm />
          </Suspense>
        ),
      },
      {
        path: "/Empolyees-trashede",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <CardListTrashed />
          </Suspense>
        ),
      },
      {
        path: "/Admin-trashede",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <CardListAdminTrashed />
          </Suspense>
        ),
      },

      {
        path: "/Notification",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <Notifcation1 />
          </Suspense>
        ),
      },
      {
        path: "/CompanyData",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <ComplaintsList />
          </Suspense>
        ),
      },
      {
        path: "/Complains",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <Filter />
          </Suspense>
        ),
      },
      {
        path: "/Complaint",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <CardListComplaint />
          </Suspense>
        ),
      },
      {
        path: "/Ratings",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <CardListRating />
          </Suspense>
        ),
      },
      {
        path: "/Deactive-client-account",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <DeactiveClient />
          </Suspense>
        ),
      },
      {
        path: "/cities",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <CIties />
          </Suspense>
        ),
      },

      {
        path: "/Company",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <CardList2 />
          </Suspense>
        ),
      },
      {
        path: "/restore-company",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <RestorCompanyTable />
          </Suspense>
        ),
      },
      {
        path: "/type_payment",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <Type_paymentTable/>
          </Suspense>
        ),
      },
      {
        path: "/company-admin",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <EmployeeAdmin />
          </Suspense>
        ),
      },
      {
        path: "/permission-user",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <Permission />
          </Suspense>
        ),
      },

      {
        path: "/privacy-policy",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <AddPrivacyPolicy />
          </Suspense>
        ),
      },
      {
        path: "/profit",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <ProfitTable />
          </Suspense>
        ),
      },
      {
        path: "/users-app",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <UsersAppTable />
          </Suspense>
        ),
      },
      {
        path: "/maintenance",
        element: (
          <Suspense fallback={  <div className="spinner1-box">
                    <svg className="spinner1" viewBox="0 0 50 50">
                      <circle
                        className="path1"
                        cx="25"
                        cy="25"
                        r="20"
                        fill="none"
                        strokeWidth="5"
                      ></circle>
                    </svg>
                  </div>}>
            <MaintenancePage />
          </Suspense>
        ),
      },
    ],
  },
]);

// function App() {
//   const isLoggedIn = localStorage.getItem("isLoggedIn");
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };
//   const handleResize = () => {
//     setIsMobile(window.innerWidth < 768);
//   };
//   useEffect(() => {
//     window.addEventListener("resize", handleResize);
//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);
//   useEffect(() => {
//     if (!isLoggedIn && window.location.pathname !== "/") {
//       window.location.href = "/";
//     }
//   }, [isLoggedIn, window.location.href]);
//   return (
//     <Provider store={store}>
//       <PersistGate loading={null} persistor={persistor}>
//         {isMobile ? (
//           <ResponsiveMessage isMobile={isMobile} setIsMobile={setIsMobile} />
//         ) : (
//           <RouterProvider router={router} toggleSidebar={toggleSidebar} />
//         )}
//       </PersistGate>
//     </Provider>
//   );
// }

// function App() {
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
//   const navigate = useNavigate();
//   const isLoggedIn = localStorage.getItem("isLoggedIn");

//   // ✅ تحسين التبديل بين الأجهزة المحمولة وغير المحمولة بدون تعليق
//   const handleResize = useCallback(() => {
//     setTimeout(() => {
//       setIsMobile(window.innerWidth < 768);
//     }, 100); // تأخير التحديث لتجنب تعليق الواجهة
//   }, []);

//   useEffect(() => {
//     window.addEventListener("resize", handleResize);
//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, [handleResize]);

//   // ✅ استخدام `useNavigate` بدلًا من `window.location.href`
//   useEffect(() => {
//     if (!isLoggedIn) {
//       navigate("/");
//     }
//   }, [isLoggedIn, navigate]);

//   return (
//     <Provider store={store}>
//       <PersistGate loading={null} persistor={persistor}>
//         {isMobile ? (
//           <ResponsiveMessage isMobile={isMobile} setIsMobile={setIsMobile} />
//         ) : (
//           <RouterProvider router={router} />
//         )}
//       </PersistGate>
//     </Provider>
//   );
// }
function App() {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const handleResize = useCallback(() => {
    setTimeout(() => {
      setIsMobile(window.innerWidth < 768);
    }, 100);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [handleResize]);

  // ✅ استخدام window.location.href فقط عند الضرورة
  useEffect(() => {
    if (!isLoggedIn && window.location.pathname !== "/") {
      window.location.href = "/";
    }
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        {isMobile ? (
          <ResponsiveMessage isMobile={isMobile} setIsMobile={setIsMobile} />
        ) : (
          <RouterProvider router={router} />
        )}
      </PersistGate>
    </Provider>
  );
}
export default App;
